// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconCeur } from "../../../icons/full/build/icon-ceur.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const CeurIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconCeur.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  CeurIcon.displayName = 'CeurIcon';
}

export default CeurIcon;